import PdfPage from "../../components/PdfPage";

export default function AccountOpenDetails() {
  return (
    <main>
      <PdfPage
        h1={"DOCUMENTS FOR ACCOUNT OPENING"}
        h2={"Account Open Detail"}
        img={
          "/img/PSX-logo.jpg"
        }
        pdf1={
          "/img/individual-form.pdf"
        }
        pdf1Text={" For Normal Account"}
        pdf2={
          "/img/sahulat_form.pdf"
        }
        pdf2Text={"For Sahulat Account"}
      />
    </main>
  );
}
